import React, { useRef, useState } from 'react';
import styled, { css } from 'styled-components';
import { Dropdown } from '../../../elements/Dropdown';
import { Icon } from '../../../elements/Icon';
import { removeEmptyString } from './utils';
import { Cell } from './Cell';
const StledDropdown = styled(Dropdown) `
  table-layout: fixed;
`;
const Label = styled.div `
  display: flex;
  justify-content: space-between;
  gap: 4px;
  width: 100%;
  align-items: center;
  border-radius: var(--table-cell-border-radius);
  box-sizing: border-box;
  box-shadow: 0 0 0 var(--input-inline-outline, 0px)
    var(--input-inline-outline-color, ${({ theme }) => theme.primary.background});
  max-width: 100%;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  color: ${({ $isFilled, theme }) => !$isFilled ? theme.secondary.blendToBackground(700) : theme.secondary.background};
  transform-origin: 0% 50%;
  transition:
    color 0.2s,
    box-shadow 0.2s,
    transform 0.2s,
    opacity 0.2s;

  &:hover {
    --input-inline-outline: 1px;
    --input-inline-outline-color: ${({ theme }) => theme.primary.background};
  }

  ${({ $isOpen }) => $isOpen &&
    css `
      --input-inline-outline: 1px;
      --input-inline-outline-color: ${({ theme }) => theme.primary.background};
    `}

  ${({ $isLoading }) => $isLoading &&
    css `
      opacity: 0;
      transform: translateX(-4px) scale(0.9);
    `}
`;
const LabelContent = styled.div `
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: table-cell;
  max-width: 100%;
`;
const Up = styled(Icon.ChevronUpLarge) `
  --icon-size: 14px;
  --icon-color: currentColor;

  pointer-events: none;
`;
const Down = styled(Icon.ChevronDownLarge) `
  --icon-size: 14px;
  --icon-color: currentColor;

  pointer-events: none;
`;
const Loading = styled(Icon.Loading) `
  --icon-color: ${({ theme }) => theme.secondary.blendToBackground(800)};

  position: absolute;
  z-index: 1;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  transition:
    transform 0.2s,
    opacity 0.2s;

  ${({ $isLoading }) => !$isLoading &&
    css `
      opacity: 0;
      transform: translateY(-12px) scale(0.75);
    `}
`;
const OptionDisplayCell = (props) => {
    return React.createElement(Cell, null, props.options.find((option) => option.value === props.value)?.label);
};
const OptionInputCell = ({ value, onChange, onClose, active, options, hiddenOptions, isLoading, ...props }) => {
    const dropdownRef = useRef(null);
    const [isOpen, setIsOpen] = useState(false);
    return (React.createElement(StledDropdown, { ...props, ref: dropdownRef, active: value ?? active, onChange: (newValue) => {
            onChange?.(newValue);
        }, customLabel: React.createElement(React.Fragment, null,
            React.createElement(Label, { "$isLoading": isLoading, "$isFilled": !![...options, ...(hiddenOptions ?? [])].find((option) => option.value === value), "$isOpen": isOpen },
                React.createElement(LabelContent, null, [...options, ...(hiddenOptions ?? [])].find((option) => option.value === value)?.label ||
                    props.placeholder ||
                    'Please select'),
                isOpen ? React.createElement(Up, null) : React.createElement(Down, null)),
            React.createElement(Loading, { "$isLoading": isLoading })), options: removeEmptyString(options), hiddenOptions: removeEmptyString(hiddenOptions ?? []), onOpenChange: (open) => {
            setIsOpen(open);
            if (!open) {
                dropdownRef.current?.clearSearch();
                onClose?.();
            }
        }, fullWidth: true }));
};
export const OptionCell = ({ isEditable, ...props }) => {
    return isEditable ? React.createElement(OptionInputCell, { ...props }) : React.createElement(OptionDisplayCell, { ...props });
};
//# sourceMappingURL=OptionCell.js.map